'use strict';
/**
 * Product List Controller
 */

var getFormattedPrice = function (price) {
    var formattedPrice = null; //ask what a 0 should return
    var tempCurrencySymbol, tempThousandSeparator, tempDecimalSeparator, tempFormat, hideDecimals, decimalsToShow;
    var symbol, negative, thousand, decimalSeparator, decimalValue, i, j;
    if (Math.round(parseInt(price)) !== 0) {
        tempCurrencySymbol = getPriceFormatValue('currencySymbol');
        tempThousandSeparator = getPriceFormatValue('thousands');
        tempDecimalSeparator = getPriceFormatValue('decimal');
        tempFormat = getPriceFormatValue('currencyFormat');
        hideDecimals = getPriceFormatValue('hideDecimals');
        symbol = tempCurrencySymbol;
        thousand = tempThousandSeparator || ',';
        tempFormat = tempFormat || '#C# #P# *';
        decimalSeparator = tempDecimalSeparator || '.';
        negative = price < 0 ? '-' : '';
        i = parseInt(price = Math.abs(+price || 0).toFixed(2), 10) + '';
        j = (j = i.length) > 3 ? j % 3 : 0;

        decimalValue = Math.abs(price - i).toFixed(2).slice(2);
        //Validate if system should show the decimals AND the decimals are different to 00
        decimalsToShow = (hideDecimals === 'false' && decimalValue !== '00') ? decimalSeparator + decimalValue : '';
        formattedPrice = negative + (j ? i.substr(0, j) + thousand : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, '$1' + thousand) + decimalsToShow;
        formattedPrice = tempFormat.replace('#P#', formattedPrice).replace('#C#', symbol).replace('*', '');
    }

    //Temporary Function Location to Decode HTML Entities
    function decodeHTMLEntities(str) {
        var element = document.createElement('div');
        if (str && typeof str === 'string') {
            // strip script/html tags
            str = str.replace(/<script[^>]*>([\S\s]*?)<\/script>/gmi, '');
            str = str.replace(/<\/?\w(?:[^"'>]|"[^"]*"|'[^']*')*>/gmi, '');
            str = str.replace('+', ' ');
            element.innerHTML = str;
            str = element.textContent;
            element.textContent = '';
        }
        return decodeURIComponent(str);
    }

    /**
     * given an price formatting id string, return AEM-supplied value from global JS object
     * @param {string} id key of value to return
     * @return {String} return value or null
     */
    function getPriceFormatValue(id) {
        var strData = null;
        if (window.hpePriceConfig && window.hpePriceConfig[id]) {
            strData = decodeHTMLEntities(window.hpePriceConfig[id]);
        }
        return strData;
    }

    return formattedPrice;
};
module.exports = {
    formatProductPrice: getFormattedPrice
};
